import MinistriesPage from "../pages/MinistriesPage";

const Ministries = () => {
    return (
        <MinistriesPage />
    )
};

export default Ministries;